import React, { useState } from 'react';
import moment from 'moment';
import { Form, InputGroup, Button } from 'react-bootstrap';
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import { FaCalendarAlt, FaTimes } from 'react-icons/fa';
import * as Yup from 'yup';

// W-0489 / T15 — Filtro de data opcional (paridade `eDtIni` Delphi UConsultaOcoAtivo.pas).
// TechSpec §3.4 (Yup .nullable().min().max()) + Gate 3 Q-04 (datepicker pt-BR).
// Substituicao defensavel: react-datepicker nao instalado no projeto;
// usamos @material-ui/pickers + MomentUtils (padrao ja vigente em RelatorioConferencia).

const filtroDataSchema = Yup.date()
  .nullable()
  .min(new Date('1900-01-01'), 'Data inválida')
  .max(new Date(), 'Data não pode ser futura');

const FiltroData = ({ value, onChange, label = 'A partir de:' }) => {
  const [erro, setErro] = useState(null);
  const [open, setOpen] = useState(false);

  const handleChange = (date) => {
    const d = date ? date.toDate() : null;
    filtroDataSchema
      .validate(d)
      .then(() => {
        setErro(null);
        onChange(d);
      })
      .catch((e) => {
        setErro(e.message);
        onChange(null);
      });
    setOpen(false);
  };

  const handleClear = (ev) => {
    if (ev && ev.preventDefault) ev.preventDefault();
    if (ev && ev.stopPropagation) ev.stopPropagation();
    setErro(null);
    onChange(null);
  };

  // Paridade Delphi R6 (UConsultaOcoAtivo.pas:538-539): ESC limpa filtro de data.
  const handleKeyDown = (ev) => {
    if (ev.key === 'Escape') {
      handleClear(ev);
    }
  };

  return (
    <Form.Group className="mb-0">
      <Form.Label className="small mb-1">{label}</Form.Label>
      <InputGroup>
        <Form.Control
          type="text"
          readOnly
          value={value ? moment(value).format('DD/MM/YYYY') : ''}
          placeholder="DD/MM/AAAA"
          onClick={() => setOpen(true)}
          onKeyDown={handleKeyDown}
          isInvalid={!!erro}
          style={{ cursor: 'pointer', backgroundColor: '#fff' }}
        />
        <InputGroup.Append>
          {value && (
            <Button
              variant="outline-secondary"
              onClick={handleClear}
              title="Limpar"
            >
              <FaTimes />
            </Button>
          )}
          <Button
            variant="outline-secondary"
            onClick={() => setOpen(true)}
            title="Selecionar data"
          >
            <FaCalendarAlt />
          </Button>
        </InputGroup.Append>
        <MuiPickersUtilsProvider utils={MomentUtils} locale="pt-br">
          <DatePicker
            open={open}
            onOpen={() => setOpen(true)}
            onClose={() => setOpen(false)}
            value={value ? moment(value) : null}
            onChange={handleChange}
            format="DD/MM/YYYY"
            minDate={moment('1900-01-01')}
            maxDate={moment()}
            cancelLabel="Cancelar"
            okLabel="OK"
            TextFieldComponent={() => null}
          />
        </MuiPickersUtilsProvider>
      </InputGroup>
      {erro && <small className="text-danger d-block mt-1">{erro}</small>}
    </Form.Group>
  );
};

export default FiltroData;
